import { FieldError } from "react-hook-form";

// Layout configuration for consistent spacing
export const LAYOUT_CONFIG = {
  noteTypeTop: "2rem",
  titleTop: "4rem",
  textAreaTopPadding: "6rem",
  textAreaMarginTop: "1.5rem",
} as const;

// Hardcoded note templates (will come from backend later)
export const NOTE_TEMPLATES_OLD = [
  {
    id: "1",
    title: "HELP Standard",
    prompt: "AI prompt",
    tpl: "Situation: \nResponse: \nAssessment: \nPlan: \n",
  },
  {
    id: "2",
    title: "General Assessment",
    prompt: "General assessment prompt",
    tpl: "Chief Complaint: \nHistory of Present Illness: \nPhysical Examination: \nAssessment: \nPlan: \n",
  },
  {
    id: "3",
    title: "Discharge Summary",
    prompt: "Discharge summary prompt",
    tpl: "Admission Date: \nDischarge Date: \nDiagnosis: \nTreatment Provided: \nDischarge Instructions: \nFollow-up: \n",
  },
] as const;
export const NOTE_TEMPLATES = [
  {
    id: "1",
    title: "Nurse Assessment",
    prompt: "",
    tpl: "",
  },
  {
    id: "2",
    title: "Nurse Continuation",
    prompt: "",
    tpl: "",
  },
  {
    id: "3",
    title: "Nurse Discharge/Handover",
    prompt: "",
    tpl: "",
  },{
    id: "4",
    title: "Medical Admission",
    prompt: "",
    tpl: "Presentation: \n\nHistory of Presenting Complaint: \n\nPrevious Medical History: \n\nPrevious Surgical History: \n\nMedications: \n\nAllergies: \n\nSocial History: \n\nFamily History: \n\nPhysical Examination: \n\nInvestigations: \n\nInitial Plan: \n",
  },{
    id: "5",
    title: "Medical Continuation",
    prompt: "",
    tpl: "",
  },{
    id: "6",
    title: "Medical Senior Review",
    prompt: "",
    tpl: "",
  },{
    id: "7",
    title: "Medical Summary/Discharge",
    prompt: "",
    tpl: "Primary Diagnosis: \n\nAdditional Diagnoses / Issues: \n\nTreatment Plan: \n\nDisposition / Follow-up: \n",
  }
] as const;

export type NoteTemplate = typeof NOTE_TEMPLATES[number];

// Shared props for template input components
export type TemplateSelectInputProps = {
  value: string;
  onChange: (value: string) => void;
  onTemplateSelect: (template: NoteTemplate | null) => void;
  error?: FieldError;
  disabled?: boolean;
};

// Template selection visual type
export const TemplateSelectVisual: "chips" | "select" = "chips";

// Form fields type
export type FormFields = {
  text: string;
  template: string;
  title: string;
};
